import {
  Button,
  Stack,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { FaPodcast } from "react-icons/fa";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import CreateLiveStream from "./CreateLiveStream";

function CreateLivestreamModal() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const redColor = useColorModeValue("#FF686B", "#FF4246");
  const roundColor = useColorModeValue("#0076FF", "#0076FF");
  const containerBgColor = useColorModeValue("#F9FAFC", "#020b19");
  return (
    <>
      <Stack
        direction="row"
        alignItems={"center"}
        bg={redColor}
        color="#fff"
        boxShadow={`2px 2px 8px 0px ${redColor}AB`}
        borderRadius="10px"
        p="5px 0px 5px 10px"
        maxW="130px"
        boxSizing="initial"
        cursor={"pointer"}
        onClick={onOpen}
      >
        <FaPodcast color="#fff" fontSize={"2em"} />
        <Button
          bg="transparent"
          size="xs"
          fontSize={"1.2em"}
          fontWeight={"700"}
          pr="15px"
        >
          Go Live
        </Button>
      </Stack>

      <Modal isOpen={isOpen} onClose={onClose} size="2xl">
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody width="fit-content">
            <CreateLiveStream />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default CreateLivestreamModal;
